<template>
  <div class="ma-4 app">
    <v-sheet v-show="showSkeletonForm" class="pa-3">
      <v-row>
        <v-col v-for="n in 3" :key="`line_form_2_col_${n}`">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
        <v-col>
          <v-skeleton-loader class="mx-auto" type="button" />
        </v-col>
      </v-row>
    </v-sheet>
    <v-form v-show="!showSkeletonForm">
      <v-row dense>
        <v-col>
          <v-datetime-picker
            label="Data início"
            v-model="datetimestart"
            :date-picker-props="dateProps"
            :time-picker-props="timeProps"
            :text-field-props="textProps"
            date-format="dd/MM/yyyy"
            time-format="HH:mm"
          >
            <template slot="dateIcon">
              <v-icon>mdi-calendar-month</v-icon>
            </template>
            <template slot="timeIcon">
              <v-icon>mdi-clock-outline</v-icon>
            </template>
            <template slot="actions" slot-scope="{ parent }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    ripple
                    outlined
                    icon
                    color="darkRed"
                    @click="cancelEvent(parent)"
                    dark
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </template>
                <span>Cancelar</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    ripple
                    outlined
                    icon
                    color="bluePcm"
                    @click="parent.okHandler"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    class="ml-2"
                  >
                    <v-icon>mdi-check</v-icon>
                  </v-btn>
                </template>
                <span>Confirmar</span>
              </v-tooltip>
            </template>
          </v-datetime-picker>
        </v-col>

        <v-col>
          <v-datetime-picker
            label="Data fim"
            v-model="datetimeend"
            :date-picker-props="dateProps"
            :time-picker-props="timeProps"
            :text-field-props="textProps"
            date-format="dd/MM/yyyy"
            time-format="HH:mm"
          >
            <template slot="dateIcon">
              <v-icon>mdi-calendar-month</v-icon>
            </template>

            <template slot="timeIcon">
              <v-icon>mdi-clock-outline</v-icon>
            </template>

            <template slot="actions" slot-scope="{ parent }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    ripple
                    outlined
                    icon
                    color="darkRed"
                    @click="cancelEvent(parent)"
                    dark
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </template>
                <span>Cancelar</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    ripple
                    outlined
                    icon
                    color="bluePcm"
                    @click="parent.okHandler"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    class="ml-2"
                  >
                    <v-icon>mdi-check</v-icon>
                  </v-btn>
                </template>
                <span>Confirmar</span>
              </v-tooltip>
            </template>
          </v-datetime-picker>
        </v-col>
        <v-col v-if="!selectByDepartament">
          <v-autocomplete
            v-model="form.operadores"
            :items="operadores"
            outlined
            multiple
            dense
            :label="'Operadores'"
            :error-messages="operadoresErrors"
            @input="$v.form.operadores.$touch()"
          >
            <template v-slot:selection="{ item, index }">
              <span v-if="index === 0">{{ item.text }}</span>
              <v-chip v-if="index === 1" small>
                <span class="caption">
                  (+{{ form.operadores.length - 1 }})
                </span>
              </v-chip>
            </template>
            <template v-slot:prepend-item>
              <v-list-item ripple @click="toggle">
                <v-list-item-action>
                  <v-icon
                    :color="form.operadores.length > 0 ? 'indigo darken-4' : ''"
                  >
                    {{ icon }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    Selecionar Todos
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item ripple @click="toggleOperadoresAtivos">
                <v-list-item-action>
                  <v-icon
                    :color="somenteOperadoresAtivos ? 'indigo darken-4' : ''"
                  >
                    {{ iconOperadoresAtivos }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    Operadores Ativos
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2" />
            </template>
          </v-autocomplete>
        </v-col>
        <v-col v-if="selectByDepartament">
          <v-autocomplete
          dense
          outlined
          multiple
          v-model="departamentosSelecionados"
          :items="departamentos"
          label="Departamento"
          :error-messages= "departamentoErrors"
          @input="$v.departamentosSelecionados.$touch()">
            <template v-slot:selection="{ item, index }">
              <span v-if="index === 0">{{ item.text }}</span>
              <v-chip v-if="index === 1" small>
                <span class="caption"> (+{{ departamentosSelecionados.length - 1 }}) </span>
              </v-chip>
            </template>
            <template v-slot:prepend-item >
              <v-list-item ripple @click="toggleDepartamento">
                <v-list-item-action>
                  <v-icon :color="departamentosSelecionados.length > 0 ? 'indigo darken-4' : ''">
                    {{ iconDepartamento }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    Selecionar Todos
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2" />
            </template>
          </v-autocomplete>
        </v-col>
        <v-col cols="2" class="text-right">
          <v-btn color="orangePcm" dark class="mr-2" @click="exportExcel">Exportar Excel</v-btn>
          <v-btn dark color="bluePcm" @click="gerar">Gerar</v-btn>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-spacer />
        <v-col cols="5" class="mt-n8 mr-9">
          <v-radio-group dense v-model="selectByDepartament" row>
            <v-radio
              label="Departamento"
              color="bluePcm"
              :value="true"
              @change="radioDepartamentoSelecionado"
            />
            <v-radio
              label="Operador"
              color="bluePcm"
              :value="false"
              @change="radioOperadorSelecionado"
            />
          </v-radio-group>
        </v-col>
      </v-row>
    </v-form>

    <v-divider class="ma-2" />

    <div v-show="showResponse">
      <v-sheet v-show="showSkeleton" class="px-3 pt-3 pb-3">
        <v-skeleton-loader class="mx-auto" type="table" />
      </v-sheet>

      <div v-show="showRelatorio">
        <ExpandList
          :panel="panel"
          :dadosOperadores="dataOperadores"
          v-show="!showSkeleton"
        />
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapActions, mapGetters } from "vuex";
import relatorioDisponibilidadeHttpService from "../_services/relatorioDisponibilidadeHttpService"

import { registerVuexModule } from "@/utils/vuexUtils";
import { initialAndFinalDateTextInputReportForm } from "@/mixins/initialAndFinalDateTextInputReportForm";

import { relatoriosDisponibilidadeMixins } from "../../../_mixins/relatoriosDisponibilidadeMixins";

import relatorioDisponibilidadeResumidoStore from "../_store";
import ExpandList from "../_components/ExpandList";

export default {
  name: "DisponibilidadeResumido",
  components: { ExpandList },

  mixins: [
    initialAndFinalDateTextInputReportForm,
    relatoriosDisponibilidadeMixins,
  ],

  data: () => ({
    panel: [],
    form: {
      dataHoraInicio: "",
      dataHoraFim: "",
      operadores: [],
    },
    dataOperadores: [],
    showResponse: false,
    showRelatorio: false,
  }),

  computed: {
    ...mapGetters("relatorioDisponiblidadeResumidoStore", ["getReportData"]),
  },

  async created() {
    registerVuexModule(
      this.$store,
      "relatorioDisponiblidadeResumidoStore",
      relatorioDisponibilidadeResumidoStore
    );
  },

  methods: {
    ...mapActions("relatorioDisponiblidadeResumidoStore", ["gerarRelatorio"]),

    // Comportamento dos radio buttons

    radioDepartamentoSelecionado() {
      this.departamentosSelecionados = [];
      this.showRelatorio = false;
    },
    radioOperadorSelecionado() {
      this.form.operadores = [];
      this.showRelatorio = false;
    },

    // ===

    async gerar() {
      this.$v.$touch();
      if (this.$v.$error) {
        this.$vuetify.goTo(1, { duration: 1000, easing: "easeOutCubic" });
        return;
      }

      // Caso outro relatorio tenha sido gerado, fecha itens que estiverem abertos antes de gerar outro
      this.panel.splice(0);
      // =====
      this.showRelatorio = true;
      this.showResponse = true;
      this.showSkeleton = true;

      this.form.dataHoraInicio = moment(this.datetimestart).format('YYYY-MM-DD HH:mm:ss')
      this.form.dataHoraFim = moment(this.datetimeend).format('YYYY-MM-DD HH:mm:ss')
      await this.gerarRelatorio(this.form)
      this.form.dataHoraInicio = moment(this.datetimestart).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      this.form.dataHoraFim = moment(this.datetimeend).format(
        "YYYY-MM-DD HH:mm:ss"
      );

      await this.gerarRelatorio(this.form);
      console.log(this.getReportData)
      this.dataOperadores = [...this.getReportData];

      this.showSkeleton = false;
    },
    async exportExcel() {
      const params = {
        dataHoraInicio: moment(this.datetimestart).format('YYYY-MM-DD HH:mm'),
        dataHoraFim: moment(this.datetimeend).format('YYYY-MM-DD HH:mm'),
        operadores: this.form.operadores,
      }
      this.$v.$touch();
      if (this.$v.$error) {
        this.$vuetify.goTo(1, { duration: 1000, easing: "easeOutCubic" });
        return;
      }else{
        window.open(relatorioDisponibilidadeHttpService.exportExcel(params))
      }
    },
  },
};
</script>

<style scoped>
.app {
  background-color: var(--v-background-base);
}
</style>
